import {ConjugationViewProps} from "../../../components/ConjugationView";
import {JapaneseVernConjugationView} from "./JapaneseVerbConjugationView";
import {JapaneseVerb} from "../types";

export function JapaneseConjugationView({word}: ConjugationViewProps) {

    if (word.partOfSpeech === "Verb") {
        return <JapaneseVernConjugationView verbInfo={word.morphology as JapaneseVerb} />
    }

    return null;

}